const commonHeaders = {
  'Content-Type': 'application/json',
  Origin: 'http://localhost:3000',
};

export { commonHeaders };
